export default "__VITE_PUBLIC_ASSET__824e04d6__"